export default "__VITE_ASSET__DeAStnKy__"